// Region-level SEO landing pages (broadest geographic intent) — full
// metropolitan coverage (13 regions, every department mapped).
// Dependency-free (no imports) so the prerender script can load it too.
// `depts` holds department slugs from lib/departments.js for internal linking.
export const REGION_PATH = "/voiture-sans-permis/region";

export const REGIONS = [
  {
    slug: "ile-de-france",
    name: "Île-de-France",
    prep: "en Île-de-France",
    depts: ["paris", "seine-et-marne", "yvelines", "essonne", "hauts-de-seine", "seine-saint-denis", "val-de-marne", "val-doise"],
  },
  {
    slug: "provence-alpes-cote-d-azur",
    name: "Provence-Alpes-Côte d'Azur",
    prep: "en Provence-Alpes-Côte d'Azur",
    depts: ["alpes-de-haute-provence", "hautes-alpes", "alpes-maritimes", "bouches-du-rhone", "var", "vaucluse"],
  },
  {
    slug: "auvergne-rhone-alpes",
    name: "Auvergne-Rhône-Alpes",
    prep: "en Auvergne-Rhône-Alpes",
    depts: ["ain", "allier", "ardeche", "cantal", "drome", "isere", "loire", "haute-loire", "puy-de-dome", "rhone", "savoie", "haute-savoie"],
  },
  {
    slug: "hauts-de-france",
    name: "Hauts-de-France",
    prep: "dans les Hauts-de-France",
    depts: ["aisne", "nord", "oise", "pas-de-calais", "somme"],
  },
  {
    slug: "occitanie",
    name: "Occitanie",
    prep: "en Occitanie",
    depts: ["ariege", "aude", "aveyron", "gard", "haute-garonne", "gers", "herault", "lot", "lozere", "hautes-pyrenees", "pyrenees-orientales", "tarn", "tarn-et-garonne"],
  },
  {
    slug: "nouvelle-aquitaine",
    name: "Nouvelle-Aquitaine",
    prep: "en Nouvelle-Aquitaine",
    depts: ["charente", "charente-maritime", "correze", "creuse", "dordogne", "gironde", "landes", "lot-et-garonne", "pyrenees-atlantiques", "deux-sevres", "vienne", "haute-vienne"],
  },
  {
    slug: "grand-est",
    name: "Grand Est",
    prep: "dans le Grand Est",
    depts: ["ardennes", "aube", "marne", "haute-marne", "meurthe-et-moselle", "meuse", "moselle", "bas-rhin", "haut-rhin", "vosges"],
  },
  {
    slug: "bretagne",
    name: "Bretagne",
    prep: "en Bretagne",
    depts: ["cotes-darmor", "finistere", "ille-et-vilaine", "morbihan"],
  },
  {
    slug: "pays-de-la-loire",
    name: "Pays de la Loire",
    prep: "dans les Pays de la Loire",
    depts: ["loire-atlantique", "maine-et-loire", "mayenne", "sarthe", "vendee"],
  },
  {
    slug: "normandie",
    name: "Normandie",
    prep: "en Normandie",
    depts: ["calvados", "eure", "manche", "orne", "seine-maritime"],
  },
  {
    slug: "centre-val-de-loire",
    name: "Centre-Val de Loire",
    prep: "dans le Centre-Val de Loire",
    depts: ["cher", "eure-et-loir", "indre", "indre-et-loire", "loir-et-cher", "loiret"],
  },
  {
    slug: "bourgogne-franche-comte",
    name: "Bourgogne-Franche-Comté",
    prep: "en Bourgogne-Franche-Comté",
    depts: ["cote-dor", "doubs", "jura", "nievre", "haute-saone", "saone-et-loire", "yonne", "territoire-de-belfort"],
  },
  {
    slug: "corse",
    name: "Corse",
    prep: "en Corse",
    depts: ["corse-du-sud", "haute-corse"],
  },
];

export function findRegion(slug) {
  return REGIONS.find((r) => r.slug === slug) || null;
}
